import { getPagePaths } from 'src/core/domain/pages';
import { convertToSlug } from 'src/core/utils/urlUtil';
import type { SeekMaxCategoryGroupsQuery } from 'src/generated/gql/graphql';
import type { CareerHubLanguage } from 'src/types';
import type {
  SeekMaxCategoryGroup,
  SeekMaxCategoryGroups,
} from 'src/types/threads';

export interface CategoryGroupsLoaderData {
  groupId: string;
  categoryId: string;
  name: string;
  description: string;
  followed: boolean;
  memberCount: {
    count: number;
    label: string;
  };
  url: string;
}

type Node = NonNullable<
  NonNullable<
    NonNullable<SeekMaxCategoryGroupsQuery['seekMaxCategoryGroups']>['edges']
  >[number]
>['node'];

const getGroupDescription = (node: Node): string => {
  if (node.__typename === 'SeekMaxCategoryGroupLocal' && node.description) {
    return node.description;
  }
  return '';
};

export const mappingGroups = (
  data: SeekMaxCategoryGroups,
  language: CareerHubLanguage,
): CategoryGroupsLoaderData[] => {
  if (data && data?.edges && data?.edges?.length > 0) {
    return data?.edges
      ?.map((group) => {
        const node = group?.node;
        if (node) {
          return {
            groupId: node?.groupId,
            categoryId: node?.categoryId,
            name: node?.name,
            description: getGroupDescription(node),
            followed: Boolean(node?.personalisedDetails?.followed),
            memberCount: {
              count: node?.memberCount?.count,
              label: node?.memberCount?.label,
            },
            url: `${getPagePaths({ language }).CommunityGroups}/${convertToSlug(
              node?.name,
            )}-${node?.categoryId}`,
          };
        }
        return undefined;
      })
      .filter((group) => group !== undefined);
  }
  return [];
};

export const mappingGroup = (
  data: SeekMaxCategoryGroup,
  language: CareerHubLanguage,
): CategoryGroupsLoaderData => {
  if (data) {
    return {
      groupId: data?.groupId,
      categoryId: data?.categoryId,
      name: data?.name,
      description: getGroupDescription(data),
      followed: Boolean(data?.personalisedDetails?.followed),
      memberCount: {
        count: data?.memberCount?.count,
        label: data?.memberCount?.label,
      },
      url: `${getPagePaths({ language }).CommunityGroups}/${convertToSlug(
        data?.name,
      )}-${data?.categoryId}`,
    };
  }
  return {
    groupId: '',
    categoryId: '',
    name: '',
    description: '',
    followed: false,
    memberCount: {
      count: 0,
      label: '',
    },
    url: `${getPagePaths({ language }).CommunityGroups}/`,
  };
};
